import { combineReducers } from '@reduxjs/toolkit';

import { calendarSlice } from './calendarSlice';
import { dateSlice } from './dateSlice';
import { distributionSlice } from './distributionSlice';
import { draggableSlice } from './draggableSlice';

export const loadingOvp = combineReducers({
  calendar: calendarSlice.reducer,
  date: dateSlice.reducer,
  distribution: distributionSlice.reducer,
  drag: draggableSlice.reducer,
});
